/**
 * Forms do not react on what happens in Shadow DOM, so to submit a from from within
 * Shadow DOM components have to manually run from.submit(), however from.submit()
 * only submits the from, it doesn't trigger a submit event nor it performs validation.
 * This function does all of that.
 */
export function submitForm(form) {
    if (!form) {
        return;
    }
    // Synthetic submit event doesn't work in React, so we just create a fake
    // submit button, and click it.
    const button = document.createElement('button');
    button.type = 'submit';
    button.style.position = 'absolute';
    button.style.width = '0';
    button.style.height = '0';
    button.style.clipPath = 'inset(50%)';
    button.style.overflow = 'hidden';
    button.style.whiteSpace = 'nowrap';
    form.append(button);
    button.click();
    button.remove();
}
/**
 * Forms can be attached to an element in two ways:
 * - by placing an element inside a from, or
 * - by referencing a from id in `from` attribute of an element
 * This function finds a form both attached by either way.
 */
export function findForm(element) {
    if (element.hasAttribute('form') && element.getAttribute('form') !== '') {
        const root = element.getRootNode();
        const formId = element.getAttribute('form');
        if (formId) {
            return root.getElementById(formId);
        }
    }
    return element.closest('form');
}
/**
 * Creates a synthetic analog of ValidityState
 */
export function createValidity(invalidReason) {
    return Object.freeze({
        valueMissing: false,
        typeMismatch: false,
        patternMismatch: false,
        tooLong: false,
        tooShort: false,
        rangeUnderflow: false,
        rangeOverflow: false,
        stepMismatch: false,
        badInput: false,
        customError: false,
        valid: true,
        ...(invalidReason ? { [invalidReason]: true, valid: false } : {}),
    });
}
export function emitInvalidEvent(element, originalInvalidEvent) {
    const hlxInvalidEvent = new CustomEvent('hlx-invalid', {
        bubbles: false,
        composed: false,
        cancelable: true,
        detail: {},
    });
    const result = element.dispatchEvent(hlxInvalidEvent);
    if (!result) {
        originalInvalidEvent?.preventDefault();
    }
    return result;
}
export function sameValidity(v1, v2) {
    for (const key in v1) {
        if (v1[key] !== v2[key]) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=form-utils.js.map